module.exports = __webpack_public_path__ + "img/Icon_Report_3.9c94d359.png";